
export class BalcaoModel {
   constructor(
      public codigo: number = 1,
      public descricao: string = '',
   ) { }
}